import axios from 'axios';
import { useEstimator } from '../context/EstimatorContext';

const useCreateEstimate = () => {
  const { setFormData } = useEstimator();

  return async (projectInfo) => {
    const payload = {
      estimateDate: projectInfo.date,
      estimatedBy: projectInfo.estimatedBy,
      requestedBy: projectInfo.requestedBy,
      projectName: projectInfo.projectName,
      projectScope: projectInfo.projectScope,
    };

    try {
      const response = await axios.post('/api/PipelinePricing/pipeline/create-estimate', payload, {
        headers: { 'Content-Type': 'application/json' },
      });

      return response.data?.id;
    } catch (err) {
      console.error('Error creating estimate:', err.response?.data || err.message);
      throw err;
    }
  };
};

export default useCreateEstimate;
